module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.user')))]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.details')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('user-form', {
    attrs: {
      "user": _vm.user
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.user.new) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.serverAccesses')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.servers,
      "border": "",
      "width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fqdn",
      "label": _vm.$t('header.fqdn')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('header.userLevel')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.selectedUserLevels[scope.row.id]) ? _c('data-form', {
          attrs: {
            "entity": _vm.selectedUserLevels[scope.row.id],
            "fields": _vm.serverAccessFields,
            "hide-buttons": ""
          },
          on: {
            "change": function (userLevelId) { return _vm.userLevelSelected(scope.row.id, userLevelId); }
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitUserLevels
    }
  }, [_vm._v(_vm._s(_vm.$t('button.submit')))])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13e883c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserDetails.vue
// module id = 1127
// module chunks = 2